module.exports = __webpack_public_path__ + "img/einkauf_lager_transport.3d60a45.svg";